import { ORDER_STATUS_COLORS } from '@/data/types/Order';
import { SxProps, Theme } from '@mui/material';

export const disabledTextSX: SxProps = {
	color: '#929292',
	fontSize: 'var(--font-size-default)',
	fontWeight: 'normal',
};

export const dateOrderSX: SxProps = {
	color: '#2C2C2C',
	fontSize: 'var(--font-size-default)',
	fontWeight: '600',
	whiteSpace: 'nowrap',
};

export const cardOrderSX: SxProps = {
	borderRadius: '6px',
	border: '1px solid #ECECEC',
};

export const titleSectionSX: SxProps = {
	color: '#333333',
	fontSize: 'var(--font-size-md)',
	fontWeight: '900',
	textTransform: 'uppercase',
};

export const noOrdersSX: SxProps = {
	display: 'flex',
	backgroundColor: '#F7F7F8',
	padding: '13px',
	'@media (max-width: 768px)': {
		flexDirection: 'column',
	},
};

export const linkComprarSX: SxProps = {
	cursor: 'pointer',
	color: '#774A91',
	paddingLeft: '10px',
	'@media (max-width: 768px)': {
		paddingLeft: '0px',
	},
};

export const OrderCardHeaderOrderSX: SxProps = {
	borderRadius: '6px 6px 0px 0px',
	backgroundColor: '#F7F7F8',
	minHeight: '40px',
	padding: '10px 21px',
	justifyContent: 'space-between',
	alignItems: 'center',
};

export const OrderCardHeaderTitleFrameSX: SxProps = {};

export const OrderCardContentFrameSX: SxProps = {
	// with: '70%',
	justifyContent: 'space-between',
	alignItems: 'center',
};

export const OrderCardContentOrderLabelSX: SxProps = {
	marginRight: '6px',
	display: 'inline',
	...disabledTextSX,
};

export const OrderCardContentOrderValueSX: SxProps = { display: 'inline', ...dateOrderSX };

export const dividerVerticalSX: SxProps = {
	mx: '12.5px',
};

export const statusOrderSX = ({ isMobile }: { isMobile: boolean }): SxProps => ({
	color: '#2C2C2C',
	fontSize: isMobile ? 'var(--font-size-body)' : 'var(--font-size-sm)',
	fontWeight: 'bold',
});

export const linkableOrderSX: SxProps<Theme> = (theme) => ({
	textDecoration: 'none',
	fontSize: 'var(--font-size-default)',
	fontWeight: '600',
	color: 'primary.main',
	'&:hover': {
		textDecoration: 'underline',
	},
	[theme.breakpoints.down('sm')]: {
		fontWeight: 400,
		textAlign: 'center',
	},
});

export const detailsProductSX: SxProps<Theme> = (theme) => ({
	color: '#2C2C2C',
	fontSize: 'var(--font-size-sm)',
	fontWeight: '600',
	textTransform: 'capitalize',
	'&:hover': {
		color: 'primary.main',
	},
	[theme.breakpoints.down('sm')]: {
		fontSize: 'var(--font-size-default)',
	},
});

export const detailsProductEmptySX: SxProps<Theme> = (theme) => ({
	color: '#2C2C2C',
	fontSize: 'var(--font-size-sm)',
	fontWeight: '600',
	[theme.breakpoints.down('sm')]: {
		fontSize: 'var(--font-size-default)',
	},
});

export const disabledTextDetailsSX: SxProps<Theme> = (theme) => ({
	color: '#707070',
	fontSize: 'var(--font-size-body)',
	fontWeight: 'normal',
	[theme.breakpoints.down('sm')]: {
		fontSize: 'var(--font-size-default)',
	},
});

export const priceDetailsSX: SxProps<Theme> = (theme) => ({
	color: '#2C2C2C',
	fontSize: 'var(--font-size-sm)',
	fontWeight: '600',
	[theme.breakpoints.down('sm')]: {
		fontSize: 'var(--font-size-default)',
	},
});

export const OrderItemDetailsFrameSX: SxProps = {
	justifyContent: 'space-between',
	alignItems: 'center',
	px: '21px',
	py: '18px',
	backgroundColor: '#fff',
	borderRadius: { md: '6px' },
};
export const OrderItemDetailsMoreThanOneFrameSX: SxProps = {
	justifyContent: 'space-between',
	alignItems: 'center',
	borderBottom: '1px solid #ECECEC',
	px: '21px',
	py: '18px',
	backgroundColor: '#fff',
	'&:last-child': {
		borderBottom: 'none',
	},
};
export const OrderItemDetailsContentSX = (mobile: boolean): SxProps => ({
	with: mobile ? '100%' : '70%',
});

export const OrderItemDetailsImageFrameSX = (mobile: boolean): SxProps => ({
	position: 'relative',
	display: 'inline-block',
	width: mobile ? '67px' : 'initial',
	cursor: mobile ? 'default' : 'pointer',
});

export const OrderItemDetailsImageSX = (mobile: boolean): SxProps => ({
	mt: '5px !important',
	width: mobile ? '67px' : '81px',
	borderRadius: '2px',
});

export const OrderItemDetailsImageBadgeSX = (mobile: boolean): SxProps => ({
	position: 'absolute',
	top: mobile ? 60 : 73,
	right: -5,
	width: '20px',
	height: '20px',
	backgroundColor: '#FFFFFF',
	borderRadius: '50%',
	border: '1px solid #C9C9C9',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	color: '#2C2C2C',
	fontWeight: '600',
	fontSize: 'var(--font-size-small)',
});

export const OrderItemDetailsAttributesFrameSX = (mobile: boolean): SxProps => ({
	paddingLeft: '20px',
	width: mobile ? '80%' : 'initial',
	justifyContent: 'center',
});

export const OrderItemDetailsActionsMobileSX: SxProps = { with: '30%' };

export const OrderItemDetailsActionButtonCardSX: SxProps = {
	width: '165px',
	height: '35px',
	borderRadius: '20px',
	backgroundColor: '#F1F1F1',
	color: '#2C2C2C',
	fontSize: 'var(--font-size-small)',
	fontWeight: '600',
	'&:hover': {
		backgroundColor: '#E1E1E1',
	},
};

export const OrderCardActionsFrameSX: SxProps = {
	backgroundColor: '#fff',
	borderRadius: '0 0 6px 6px',
};

export const OrderCardActionDetailsFrameSX: SxProps = {
	padding: '10px',
	borderTop: '1px solid #ECECEC',
	borderRight: '1px solid #ECECEC',
	display: 'flex',
	justifyContent: 'center',
};

export const OrderCardActionCartFrameSX: SxProps = {
	padding: '10px',
	display: 'flex',
	justifyContent: 'center',
	borderTop: '1px solid #ECECEC',
};

export const OrderCardActionStatusSX = (isMobile: boolean, color: string): SxProps => ({
	...statusOrderSX({ isMobile }),
	color,
});
